import axios from 'axios';

const getPageData = async (pageId) => {
    try {
        const resp = await axios.post('/api/page/get-page', { pageId: pageId });
        return resp;
    } catch (err) {
        // Handle Error Here
        console.error(err);
    }
};

export default {
    getPageData
}
